import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly-payment-details',
  templateUrl: './monthly-payment-details.component.html',
  styleUrls: ['./monthly-payment-details.component.scss']
})
export class MonthlyPaymentDetailsComponent implements OnInit {
 @Input() totalMonthlyPayment: number = 0;
 @Input() tenureInYears: number = 30;
 @Input() apr: number = 6.97;
 @Input() legends = [
  { label: 'Principal & Interest', color: '#00BCD5', value:  123},
  { label: 'Property Tax', color: '#FFC208', value: 133 },
  { label: 'Home Insurance', color: '#FF9801', value: 456 },
  { label: 'HOA Fees', color: '#3F51B5', value: 122 }
];

  constructor() { }
  
  ngOnInit() {
  }

}
